import Phaser from "phaser";
import { areAssetsLoaded, data } from "../data";
export default class Preload extends Phaser.Scene {
  data;
  /** @type {Phaser.GameObjects.Text} */
  loadingText;
  /** @type {Phaser.GameObjects.Rectangle} */
  bar;
  constructor() {
    super("preload");
  }
  init() {
    this.data = data();
  }
  preload() {
    this.load.audio("bgSound", "./assets/sounds/background2.wav");
    this.load.audio("jumpSound", "./assets/sounds/jump2.wav");
    this.load.audio("slotClick", "./assets/sounds/slotClick.wav");
    this.load.audio("unlockClick", "./assets/sounds/unlockClick.mp3");
    this.load.audio("lose", "./assets/sounds/loss1.wav");
    this.load.audio("win", "./assets/sounds/win1.wav");
    this.load.image("title", "./assets/background/title.png");
    this.load.image("freePlay", "./assets/icons/freePlay.png");
    this.load.image("speaker", "./assets/icons/speaker.png");
    this.load.image("circle", "./assets/icons/circle.png");
    this.load.image("exit", "./assets/buttons/Exit.png");
    this.load.image("pause", "./assets/buttons/pause.png");
    this.load.image("restart", "../assets/buttons/Restart.png");
    this.load.image("settings", "./assets/buttons/Settings.png");
    this.load.image("start", "./assets/buttons/Start.png");
    this.load.image("play", "./assets/buttons/Play.png");
    this.load.image("continue", "./assets/buttons/Continue.png");
    this.load.image("resume", "./assets/buttons/Resume.png");
    this.load.image("back", "./assets/buttons/Back.png");
    this.load.image("home", "./assets/buttons/Home.png");
    this.load.image("refresh", "./assets/buttons/Refresh.png");
    this.load.image("bambooFrame", "./assets/background/bambooFrame.png");
    this.load.image("chestClosed", "./assets/chest/chestClosed.png");
    this.load.image("chestCrack", "./assets/chest/chestCrack.png");
    this.load.image("chestOpen", "./assets/chest/chestOpen.png");
    this.load.image("pitFall", "./assets/stones/pitfall.png");
    // background
    for (let i = 0; i < 5; i++) {
      this.load.image(
        `bg${i}`,
        `./assets/background/Bamboo_Forest_BG_Day_Layer_0${i}.png`
      );
    }
    for (let i = 0; i < 4; i++) {
      this.load.image(`coin${i}`, `./assets/coin/Coin_000000${i}.png`);
    }
    // character
    this.load.image("idle", "./assets/idle/idle.png");
    for (let i = 0; i < 5; i++) {
      this.load.image(`jump${i}`, `./assets/jump/Jump_00${i}.png`);
    }
    for (let i = 0; i < 8; i++) {
      this.load.image(`run${i}`, `./assets/run/Run_00${i}.png`);
    }
    for (let i = 0; i < 3; i++) {
      this.load.image(`dizzy${i}`, `./assets/dizzy/Dizzy_00${i}.png`);
    }
    for (let i = 0; i < 4; i++) {
      this.load.image(`slide${i}`, `./assets/slide/Sliding_00${i}.png`);
    }
    // skinned character
    this.load.image("skinnedIdle", "./assets/idle/skinnedIdle.png");
    for (let i = 0; i < 4; i++) {
      this.load.image(
        `skinnedJump${i}`,
        `./assets/skinned/skinnedJump/Jump_00${i}.png`
      );
    }
    for (let i = 0; i < 8; i++) {
      this.load.image(
        `skinnedRun${i}`,
        `./assets/skinned/skinnedRun/Run_00${i}.png`
      );
    }
    for (let i = 0; i < 3; i++) {
      this.load.image(
        `skinnedDizzy${i}`,
        `./assets/skinned/skinnedDizzy/Dizzy_00${i}.png`
      );
    }
    for (let i = 0; i < 4; i++) {
      this.load.image(
        `skinnedSlide${i}`,
        `./assets/skinned/skinnedSlide/Sliding_00${i}.png`
      );
    }
    // stones
    for (let i = 0; i < 11; i++) {
      if (i === 10) {
        this.load.image(
          `stone${i}`,
          `./assets/stones/stone_grey_x256_${i}.png`
        );
      } else {
        this.load.image(
          `stone${i}`,
          `./assets/stones/stone_grey_x256_0${i}.png`
        );
      }
    }
    for (let i = 3; i < 11; i++) {
      if (i === 10) {
        this.load.image(
          `stone${i + 8}`,
          `./assets/stones/stone_grey_x256_${i}.png`
        );
      } else {
        this.load.image(
          `stone${i + 8}`,
          `./assets/stones/stone_grey_x256_0${i}s.png`
        );
      }
    }
    this.load.image("stick", "./assets/bamboo/stick.png");
    this.load.image("pile", "./assets/bamboo/pile.png");
    for (let i = 0; i < 5; i++) {
      this.load.image(`poof${i}`, `./assets/bamboo/poof${i}.png`);
    }
    this.load.image("longBar", "./assets/slot/bars/longBar.png");
    this.load.image("shortBar", "./assets/slot/bars/shortBar.png");
    this.load.image("thickBar", "./assets/slot/bars/thickBar.png");
    this.load.image("smallBar", "./assets/slot/bars/smallBar.png");
    this.load.image("pandaBar", "./assets/slot/bars/pandaBar.png");
    this.load.image("coinBar", "./assets/slot/bars/coinBar.png");
    this.load.image("5Coin", "./assets/slot/items/5Coin.png");
    this.load.image("10Coin", "./assets/slot/items/10Coin.png");
    this.load.image("freePlayIcon", "./assets/slot/items/freePlayIcon.png");
    this.load.image("key", "./assets/slot/items/key.png");
    this.load.image("outfit", "./assets/slot/items/outfit.png");
    this.load.image("outfitGlow1", "./assets/slot/items/outfitGlow1.png");
    this.load.image("outfitGlow2", "./assets/slot/items/outfitGlow2.png");
    this.load.image("gameBoard", "./assets/slot/items/gameBoard.png");
    this.load.image("blackRect", "./assets/slot/items/blackRect.png");
    this.load.image("blackRectBlur", "./assets/slot/items/blackRectBlur.png");
    this.load.image("xIcon", "./assets/slot/items/xIcon.png");
    this.load.image("arrowIcon", "./assets/slot/items/arrowIcon.png");
    this.load.on("start", (e) => {
      this.add
        .image(0, 0, "startBg")
        .setOrigin(0)
        .setDisplaySize(this.sys.canvas.width, this.sys.canvas.height);
      this.loadingText = this.add
        .text(
          this.sys.canvas.width / 2,
          this.sys.canvas.height * 0.5,
          "Loading...",
          {
            fontFamily: "Grooving",
            color: "#d6a226",
            fontSize: "40px",
            strokeThickness: 3,
            stroke: 0x0000,
          }
        )
        .setOrigin(0.5)
        .setScale(this.data.scaleX);
      this.rec = this.add.rectangle(
        this.sys.canvas.width * 0.2,
        this.sys.canvas.height * 0.6,
        0 * this.data.scaleX,
        20 * this.data.scaleX,
        0xd6a226
      );
    });
    this.load.on("progress", (e) => {
      this.loadingText.setText(`Loading(${Math.round(e * 100)}%)...`);
      this.rec.width = e * 600 * this.data.scaleX;
    });
    this.load.on("complete", (e) => {
      this.loadingText.setText("Starting...");
    });
  }
  create() {
    areAssetsLoaded.value = true;
    this.scene.start("instructions");
  }
}
